import { Button } from '@monksflow/monks-ui';
import { STEPPER_PAGE_MAX_WIDTH } from './ActionFooter.constants';
import type { ActionFooterProps } from './ActionFooter.types';
import { useTranslation } from 'react-i18next';

export const ActionFooter = (props: ActionFooterProps) => {
  const { t } = useTranslation('common');

  const {
    activeStep,
    totalSteps,
    enableNext = true,
    onBack,
    onNext,
    onCancel,
    nextLabel = t('components.actionFooter.next'),
    lastStepLabel = t('components.actionFooter.generate'),
    onSkip,
    skipLabel = t('components.actionFooter.skip'),
    maxWidth = STEPPER_PAGE_MAX_WIDTH,
    isSubmitting = false,
  } = props;

  const isFirstStep = activeStep === 0;
  const isLastStep = activeStep === totalSteps - 1;

  return (
    <footer
      data-testid="action-footer"
      className="flex w-full mx-auto justify-between items-center gap-2"
      style={{ maxWidth }}
    >
      {onCancel && (
        <Button variant="ghost" onClick={onCancel}>
          {t('components.actionFooter.cancel')}
        </Button>
      )}

      <div className="flex gap-2 ml-auto">
        {!isFirstStep && onBack && (
          <Button variant="outline" onClick={onBack}>
            {t('components.actionFooter.back')}
          </Button>
        )}
        {isFirstStep && onSkip && (
          <Button variant="outline" onClick={onSkip}>
            {skipLabel}
          </Button>
        )}
        <Button variant="default" disabled={!enableNext || isSubmitting} onClick={onNext}>
          {isLastStep ? lastStepLabel : nextLabel}
        </Button>
      </div>
    </footer>
  );
};
